import React from "react";
import { TextFont, Colors } from "../../config";
import styled from "styled-components";
import InputField from "../../components/InputField";

const CommentSection = ({ formData, handleCommentChange }) => {
  return (
    <CommentWrapper>
      <TextFont fontColor={Colors.brandTwo} fontSize="1.5rem" fontWeight="700">
        Any special requests?
      </TextFont>
      <InpWrapper>
        <InputField
          placeholder="Add note"
          value={formData.bookingComments}
          onChange={handleCommentChange}
          isRounded
        />
      </InpWrapper>
    </CommentWrapper>
  );
};

export default CommentSection;

const CommentWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    padding: 0 1rem;
  }
`;
const InpWrapper = styled.div`
  padding: 1rem 0;
`;
